import i18n from 'i18next'
import { reactI18nextModule } from 'react-i18next'
import Backend from 'i18next-xhr-backend';
i18n
.use(Backend)
.use(reactI18nextModule)
  .init({
    backend: {
         loadPath: './LngData/{{lng}}/{{ns}}.json'
      },
    lng:'th',
    fallbackLng: 'th',
    interpolation: {
        escapeValue: false
      }
  })

  export default i18n


// WEBPACK FOOTER //
// ./src/i18n.js